import React, {PropTypes} from 'react';

class CalendarRecommendations extends React.Component {

  componentDidMount() {
    // Activate Bootstrap tooltips
    $('[data-toggle="tooltip"]').tooltip();
  }

  render () {
    // Months
    let monthsTags = [];
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    for (let i = 0; i < months.length; i++) {
      let selected = '';
      if (i + 1 == this.props.currentMonth) {
        selected = 'selected';
      }
      monthsTags.push(<th key={i} className={selected}>{months[i]}</th>);
    }

    // Recommendations
    let recommended = this.props.recommended;
    let recommendedTags = [];
    $.each(recommended, function(key, month) {
      let pictos = month['pictos'];
      let pictosTags = [];
      for (let i in pictos) {
        let picto = '';
        if (pictos[i]['ico'] == 'rain' && month['color'] == 'average') {
            picto = 'picto-rain-white.png';
        } else {
            picto = 'picto-' + pictos[i]['ico'] + '.png';
        }
        let picto_img = <a key={i} data-toggle="tooltip" data-placement="top" title={pictos[i]["msg"]}><img className="picto" src={require('../images/'+picto)} width="16" height="16" /></a>;
        pictosTags.push(picto_img);
      }
      recommendedTags.push(
        <td key={key} className={month['color']}>
          {pictosTags}
        </td>
      );
    });

    // Title is displayed only for big graphes
    let title;
    if (this.props.size === 'big') {
      title = (
        <tr>
          <td colSpan="3">
          </td>
          <td colSpan="6" className="metric-title">
            Weather
          </td>
          <td colSpan="3" className="sources">
            <a data-toggle="modal" data-target="#sources" href="#sources">
              Sources
            </a>
          </td>
        </tr>
      )
    }

    // Initial width
    let tableStyle = {
      width: this.props.initialWidth
    };

    return (
      <div>
        <div className="calendar-container">
          <table className="calendar" style={tableStyle}>
            <tbody>
              <tr>
                {monthsTags}
              </tr>
              <tr className="recommended-row">
                {recommendedTags}
              </tr>
              {title}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

CalendarRecommendations.propTypes = {
  recommended: PropTypes.array.isRequired,
  size: PropTypes.string.isRequired,
  currentMonth: PropTypes.number.isRequired,
  initialWidth: PropTypes.string.isRequired
};

export default CalendarRecommendations;



/** WEBPACK FOOTER **
 ** ./src/components/CalendarRecommendations.js
 **/